import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PedidoItemLinhaVendido } from '../vendido';

@Injectable({
    providedIn: 'root'
})
export class PedidoItemVendidoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido/0/item/vendidos`
    }

    // Pesquisa os itens vendidos para a pessoa informada
    SearchVendidosPessoa(idPessoa: number): Observable<PedidoItemLinhaVendido[]> {
        return this.customHttp.get<PedidoItemLinhaVendido[]>(`${this.pathApi}/pessoa/${idPessoa}`);
    }
}
